module.exports = __webpack_public_path__ + "static/media/whitewomen.88c3bad0.png";